import { useEffect } from "react";
import { useLocation } from "react-router-dom";


function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
        page_title: document.title,
      });
    }
  }, [location]);
}


export default usePageTracking;